import mainStore from '@components/Main/store'
import { HOME_PATH } from '@constant'
import { isUltimate } from '@merchant-backend/util'
import { getAuthId, notUltimateAlert } from '@util'
import { Button } from 'hljd'
import { observer } from 'mobx-react'
import React, { Children, cloneElement, Component } from 'react'
import { hashHistory } from 'react-router'
import { GlobalContext } from '../../globalContext'
import ErrorView from '../ErrorView'

export class AuthPro extends Component {
  static NotShow = ({ children = null, condition = isUltimate() }) => {
    return condition ? null : children
  }

  static Show = ({ children = null, condition = isUltimate() }) => {
    return condition ? children : null
  }

  handleClick = () => {
    if (isUltimate()) {
      this.props.onClick()
    } else {
      notUltimateAlert()
    }
  }

  handleChildren = children => {
    return Children.map(children, child =>
      cloneElement(child, {
        onClick: this.handleClick
      })
    )
  }

  render() {
    return this.handleChildren(this.props.children)
  }
}

const isRoleAuthed = role => {
  return role.includes(getAuthId())
}

const isNullOrUndefined = value => {
  const result = Object.prototype.toString.call(value)
  return result === '[object Null]' || result === '[object Undefined]'
}

/**
 * @param {Array} role 身份数组，当前登录身份在此数组内才有权限
 * @param {String} type 是否是路由权限控制
 */
export const Auth = ({ condition, role = [], type, children } = {}) => {
  if (React.isValidElement(children)) {
    if (!isNullOrUndefined(condition)) {
      return condition ? children : null
    }

    return isRoleAuthed(role) ? children : null
  }

  // TODO，移除这个逻辑
  const isRoute = type === 'route'

  return WrappedComponent => {
    @observer
    class InnerComponent extends Component {
      checkAuth = () => {
        let isAuthed

        if (role.length === 0) {
          isAuthed = false
        } else {
          isAuthed = isRoleAuthed(role)
        }

        return isAuthed
      }

      render() {
        return (
          <GlobalContext.Consumer>
            {({ merchantInfo } = {}) => {
              return this.checkAuth() ? (
                <WrappedComponent {...this.props} />
              ) : isRoute ? (
                <ErrorView>
                  <Button
                    type="primary"
                    onClick={() => hashHistory.push(HOME_PATH)}
                  >
                    回到主页
                  </Button>
                </ErrorView>
              ) : null
            }}
          </GlobalContext.Consumer>
        )
      }
    }

    return InnerComponent
  }
}

/**
 * 检查权限，无权限则跳转
 * 有产品ID直接跳至营销页
 */
export const AuthTo = ({ isAuthed, link, productId }) => WrappedComponent => {
  return class extends Component {
    constructor(props) {
      super(props)

      this.authed = isAuthed()

      if (!this.authed) {
        const l = link || `/localMerchant/marketingCenter/detail/${productId}`
        hashHistory.replace(l)
        return
      }
    }
    render() {
      return this.authed ? <WrappedComponent {...this.props} /> : null
    }
  }
}

/**
 * 产品是否有权限
 */
export const AuthProduct = observer(
  ({ id, noAuthRender = () => {}, children }) => {
    const { productAuth } = mainStore
    const product = productAuth.find(p => p.policyCode == id)

    // http://autotest.hunliji.com/web/#/home/project/api/edit?projectId=-701335349&apiId=216026&moduleid=5199
    // http://api.hljnbw.cn/project/735/interface/api/97567
    return product && product.showStatus == 1 ? children : noAuthRender()
  }
)
